import SpinningLoader from '../../../../../components/loaders/SpinningLoader'

// Generic header+rows table shared by Top Contributions / My Contributions /
// Prizes / Results — the four jackpot tables that are all "header row + a
// scrollable list of rows", differing only in columns and per-row rendering.
// `medalRows` adds the gold/silver/bronze `:nth-child` border modifier (Prizes
// and Results only — see _jackpotTable.scss).
const JackpotTable = ({
  headers,
  rows,
  renderRow,
  isPending,
  isError,
  emptyMessage = 'Nothing here yet',
  currencyCode,
  medalRows = false,
}) => {
  if (isPending) {
    return (
      <div className="standard-normal-jackpot-table-state-container">
        <SpinningLoader />
      </div>
    )
  }

  if (isError || !rows.length) {
    return (
      <div className="standard-normal-jackpot-table-state-container">
        {isError ? 'Ooops! Something Went Wrong!' : emptyMessage}
      </div>
    )
  }

  return (
    <div className="standard-normal-jackpot-table-outer-container">
      <div className="standard-normal-jackpot-table-header-row">
        {headers.map((header) => (
          <div key={header.key} className="standard-normal-jackpot-table-header-element">
            <span>{header.label}</span>
            {header.showCurrency && (
              <span className="standard-normal-jackpot-table-header-currency">({currencyCode})</span>
            )}
          </div>
        ))}
      </div>
      <div
        className={`standard-normal-jackpot-table-body no-scrollbar ${medalRows ? 'standard-normal-jackpot-table-body-medals' : ''}`}
      >
        {rows.map((row, index) => renderRow(row, index))}
      </div>
    </div>
  )
}

export default JackpotTable
